import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import {
  FieldMapping,
  FieldMappingCreateParams,
  UpdateFieldMappingsPositionsParams,
} from '../../../types';
import { FieldMappingHttpClient } from './field-mapping-http.client';

@Injectable({ providedIn: 'root' })
export class FieldMappingStoreService {
  constructor(private httpClient: FieldMappingHttpClient) {}

  public createFieldMappings(
    integrationKind: string,
    formConfigId: number,
    params: FieldMappingCreateParams,
  ): Observable<FieldMapping[]> {
    return this.httpClient.createFieldMappings(integrationKind, formConfigId, params);
  }

  public deleteFieldMapping(integrationKind: string, fieldMappingId: number): Observable<any> {
    return this.httpClient.deleteFieldMapping(integrationKind, fieldMappingId);
  }

  public updateFieldMappingsPositions(
    integrationKind: string,
    formConfigId: number,
    params: UpdateFieldMappingsPositionsParams,
  ): Observable<any> {
    return this.httpClient.updateFieldMappingsPositions(integrationKind, formConfigId, params);
  }
}
